import registerInline from './decorators/inline';

export function registerDefaultDecorators(instance) {
  registerInline(instance);
}



// WEBPACK FOOTER //
// ../../../lib/handlebars/decorators.js